import React from "react"; 
import { AiOutlineDownload } from 'react-icons/ai'; 
import { HiOutlineViewList } from 'react-icons/hi';
 import './style.css';
  let Result=(props)=> { 
    return(
  <div>
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="centerME">
      <div className="boxStAc1">
        <div className="headi">
          <h3 style={{padding:10,textAlign: 'center'}}>
  
  Result
  
  </h3>
          <div className="contentMe">
            <p style={{fontSize:17,fontWeight: '500'}}>As Per the input given to the statment djsfk fjsnd fjd afjd fjdm fdjsfm asdjfm sdfdsnm fd</p>
            <h1 style={{fontSize:44,color: 'red',fontWeight: '500'}}>
      NO GO
  </h1>
            <p style={{fontSize:15}}>As Per the input given to the statment djsfk fjsnd fjd afjd fjdm fdjsfm asdjfm sdfdsnm fd As Per the input given to the statment djsfk fjsnd fjd afjd fjdm fdjsfm asdjfm sdfdsnm fd As Per the input given to the statment djsfk fjsnd fjd afjd fjdm fdjsfm asdjfm sdfdsnm fd</p>
          </div>
          <button className="button" style={{width:150,height:40,backgroundColor: '#FFCD24',borderRadius:4,borderWidth:0,marginTop:0,display: 'flex',alignItems: 'center',justifyContent: 'space-around',paddingLeft:10,paddingRight:10}}>Download
            <AiOutlineDownload />
          </button>
        </div>
        <div className="scoreRate">
          <div>
            <h1 style={{fontSize:44,color: 'green',fontWeight: '500'}}>
      34
  </h1>
            <p style={{fontSize:20,fontWeight: 'bold'}}>Opportunity SCore</p>
          </div>
          <div class="vl"></div>
          <div>
            <h1 style={{fontSize:44,color: 'red',fontWeight: '500'}}>
      34
  </h1>
            <p style={{fontSize:20,fontWeight: 'bold'}}>Opportunity SCore</p>
          </div>
        </div>
        <div className="mainBoxOF" style={{display: 'flex',alignItems: 'center',justifyContent: 'space-around'}}>
          <div className="scoreTable">
            <div className="sectionInn">
              <p>Problem Score</p>
              <p>28</p>
            </div>
            <div className="sectionInn">
              <p>Problem Score</p>
              <p>28</p>
            </div>
            <div className="sectionInn">
              <p>Problem Score</p>
              <p>28</p>
            </div>
            <div className="sectionInn">
              <p>Problem Score</p>
              <p>28</p>
            </div>
            <div className="sectionInn">
              <p>Problem Score</p>
              <p>28</p>
            </div>
            <div className="sectionInn">
              <p>Problem Score</p>
              <p>28</p>
            </div>
          </div>
          <div className="scoreTable">
            <div className="sectionInn">
              <p>Problem Score</p>
              <p>28</p>
            </div>
            <div className="sectionInn">
              <p>Problem Score</p>
              <p>28</p>
            </div>
            <div className="sectionInn">
              <p>Problem Score</p>
              <p>28</p>
            </div>
            <div className="sectionInn">
              <p>Problem Score</p>
              <p>28</p>
            </div>
            <div className="sectionInn">
              <p>Problem Score</p>
              <p>28</p>
            </div>
            <div className="sectionInn">
              <p>Problem Score</p>
              <p>28</p>
            </div>
          </div>
        </div>
        <h3 style={{padding:20}}>
    Summary and Recomandation
  </h3>
        <table id="tableAll">
          <tbody>
            <tr>
              <td data-label="" id='forcecenter'>Problem Score</td>
              <td data-label="" id='forcecenter'>28</td>
              <td data-label="" id='forcecenter'>Problem Vaidation</td>
            </tr>
            <tr>
              <td data-label="" id='forcecenter'>Problem Score</td>
              <td data-label="" id='forcecenter'>28</td>
              <td data-label="" id='forcecenter'>Problem Vaidation</td>
            </tr>
            <tr>
              <td data-label="" id='forcecenter'>Problem Score</td>
              <td data-label="" id='forcecenter'>28</td>
              <td data-label="" id='forcecenter'>Problem Vaidation</td>
            </tr>
            <tr>
              <td data-label="" id='forcecenter'>Problem Score</td>
              <td data-label="" id='forcecenter'>28</td>
              <td data-label="" id='forcecenter'>Problem Vaidation</td>
            </tr>
            <tr>
              <td data-label="" id='forcecenter'>Problem Score</td>
              <td data-label="" id='forcecenter'>28</td>
              <td data-label="" id='forcecenter'>Problem Vaidation</td>
            </tr>
            <tr>
              <td data-label="" id='forcecenter'>Problem Score</td>
              <td data-label="" id='forcecenter'>28</td>
              <td data-label="" id='forcecenter'>Problem Vaidation</td>
            </tr>
            <tr>
              <td data-label="" id='forcecenter'>Problem Score</td>
              <td data-label="" id='forcecenter'>28</td>
              <td data-label="" id='forcecenter'>Problem Vaidation</td>
            </tr>
            <tr>
              <td data-label="" id='forcecenter'>Problem Score</td>
              <td data-label="" id='forcecenter'>28</td>
              <td data-label="" id='forcecenter'>Problem Vaidation</td>
            </tr>
            <tr>
              <td data-label="" id='forcecenter'>Problem Score</td>
              <td data-label="" id='forcecenter'>28</td>
              <td data-label="" id='forcecenter'>Problem Vaidation</td>
            </tr>
            <tr>
              <td data-label="" id='forcecenter'>Problem Score</td>
              <td data-label="" id='forcecenter'>28</td>
              <td data-label="" id='forcecenter'>Problem Vaidation</td>
            </tr>
          </tbody>
        </table>
        <div id="flexLef">
          <button className="button2" onClick={()=>props.history.push('/demndPeak')} id='BackNext'>Back</button>
          <button className="button2" onClick={()=>props.history.push('/adminDash')} id='BackNext'>Next</button>
        </div>
      </div>
    </div>
  </div>) 
  } 
  export default Result;